import { render, staticRenderFns } from "./TrendyolChannels.vue?vue&type=template&id=ddd09d62&scoped=true"
import script from "./TrendyolChannels.vue?vue&type=script&lang=js"
export * from "./TrendyolChannels.vue?vue&type=script&lang=js"
import style0 from "./TrendyolChannels.vue?vue&type=style&index=0&id=ddd09d62&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddd09d62",
  null
  
)

export default component.exports